// extracted by mini-css-extract-plugin
export default {"wrap":"ModooCarListFilters_wrap__WeDPq","locationWrap":"ModooCarListFilters_locationWrap__A2ZmZ","carTypeWrap":"ModooCarListFilters_carTypeWrap__Roqrd"};